export default class TranslationUtility {
    /**
     * @param {*} map A dictionary of translation keys to the translated texts
     */
    constructor(map) {
        this._translationMap = map;
        this._language = document.documentElement.lang.toLowerCase();
    }

    /**
     * Returns the language to use
     *
     * @returns {string}
     */
    get language() {
        return this._language;
    }

    /**
     * Returns the translation for the given key
     *
     * @param {string} key
     * @param {*} variables
     * @returns {string}
     */
    translate(key, ...variables) {
        if (typeof key !== 'string') {
            throw new TypeError('Argument "key" must be of type string');
        }

        return this._replaceParts(this._getTranslation(key), variables);
    }

    /**
     * @param {string} key
     * @return {string}
     * @private
     */
    _getTranslation(key) {
        return this._translationMap[key] || '';
    }

    /**
     * @param {string} format
     * @param {*[]} variables
     * @return {string}
     * @private
     */
    _replaceParts(format, variables) {
        const current = variables.shift();
        const output = format.replace(/%s/, '' + current);

        if (variables.length > 0) {
            return this._replaceParts(output, variables)
        }

        return '' + output;
    }
}



// WEBPACK FOOTER //
// ./Resources/Private/JavaScripts/src/TranslationUtility.js